import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
Vue.use(VueCookies)

const getters = {
        login_status: state => state.authenticated,
        type: state => state.type,
        name: state => state.name,
        permission: state => state.permission,
        isScan: (state) => {
            if (state.type == 'admin' && (state.permission == 'scan' || state.permission == 'venue' || state.permission == 'admin' || state.permission == 'manager' || state.permission == 'master')) {
                return true;
            }
            return false;
        },
        isVenue: (state) => {
            console.log("isVenue")
            console.log(state.type)
            if (state.type == 'admin' && (state.permission == 'venue' || state.permission == 'admin' || state.permission == 'manager' || state.permission == 'master')) {
                return true;
            }
            return false;
        },
        isAdmin: (state) => {
            console.log("isAdmin")
            console.log(state.type)
            console.log(state.permission)
            if (state.type == 'admin' && (state.permission == 'admin' || state.permission == 'manager' || state.permission == 'master')) {
                return true;
            }
            return false;
        },
        isManager: (state) => {
            if (state.type == 'admin' && (state.permission == 'manager' || state.permission == 'master')) {
                return true;
            }
            return false;
        },
        isMaster: (state) => {
            if (state.type == 'admin' && (state.permission == 'master')) {
                return true;
            }
            return false;
        },
        isOrganizer: (state) => {
            if (state.type == 'admin') {
                return false;
            }
            return true;
        },
    }
    // const dataState = createPersistedState({
    //     paths: ['data']
    // })


export default new Vuex.Store({
    state: {
        authenticated: false,
        darkmode: false,
        share_data: null,
        user_data: null,
        name: '',
        permission: '',
        type: '',
        route_link: '',
    },
    mutations: {
        setShareData(state, data) {
            state.share_data = data
        },
        setLoginData(state) {
            state.authenticated = true
        },
        setUser(state, data) {
            state.user_data = data
        },
        setName(state, data) {
            state.name = data
        },
        setPermission(state, data) {
            state.permission = data
        },
        setType(state, data) {
            state.type = data
        },
        resetData(state) {
            state.login_data = [];
            state.login_status = false
            state.user_data = null
            Object.assign(state, {
                authenticated: false,
                darkmode: false,
            })
        },
    },
    actions: {
        getData({ commit }, data) {
            commit(data.method)
        },
        reset({ commit }, data) {
            commit(data.method)
        },
    },
    getters,
    modules: {},
    plugins: [createPersistedState({
        // storage: window.sessionStorage
    })],
})